<template>
  <div>
    <Navbar/>
    <SmallHeader/>
    <main>
      <Cursos/>
      <EmailForm />
      <Servicos/>

    </main>
    <Footer/>
  </div>
</template>
<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import SmallHeader from '@/components/SmallHeader.vue'
import Footer from '@/components/Footer.vue'
import Cursos from '@/components/cursos/Cursos.vue'
import Servicos from '@/components/cursos/Servicos.vue'
import EmailForm from '@/components/cursos/EmailForm.vue'

export default {
  name: 'home',
  components: {
    Navbar,
    SmallHeader,
    Footer,
    Cursos,
    Servicos,
    EmailForm,
  },
  mounted() {
    if (/\?form=ok/.test(window.location.href)) {
      alert('Email enviado');
      window.location.search = '';
    }
  }
}
</script>
